// dls
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";

// lib
import styled from "styled-components";

// constants
import { COLORS, TRUNCATE_LINE } from "./constant";

export const CurtainRaiserContainer = styled.div<{
    isSwipeUp?: boolean;
    translateYPosition?: number;
}>(({ isSwipeUp, translateYPosition = 0, theme }) => {
    const containerHeight = typeof window !== "undefined" ? `${window.innerHeight}px` : "100vh";

    return {
        zIndex: 100,
        background: theme.colors[theme.colorMode].background_inverse_Primary,
        width: "100vw",
        height: containerHeight,
        flex: 1,
        textAlign: "center",
        transition: isSwipeUp ? "transform 1s ease-out" : "none",
        transform: isSwipeUp ? "translateY(-100vh)" : `translateY(${translateYPosition}px)`,
    };
});

export const ImageBackground = styled.div<{ imgUrl: string; isLoaded: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${({ imgUrl }) => imgUrl}) no-repeat center center;
    background-size: cover;
    opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
    transition: opacity 0.5s ease-in-out;
`;

export const ContentContainer = styled.button(({ theme }) => ({
    position: "absolute",
    bottom: 0,
    padding: theme.spacing.large,
    "@supports not (-webkit-touch-callout: none)": {
        paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.large})`,
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: "100%",
    touchAction: "none",
}));

export const RestaurantContainer = styled.div({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "44px",
});

export const ArtDecoRight = styled(Image)({
    transform: "rotateY(180deg)",
});

export const LogoContainer = styled.div(({ theme }) => ({
    width: "76px",
    height: "76px",
    padding: theme.spacing.xSmall,
    backgroundColor: theme.colors.light.background_Primary,
    marginBottom: theme.spacing.large,
    borderRadius: theme.cornerRadius.small,
}));

export const UserText = styled(Text)({
    letterSpacing: "1.5px",
    color: COLORS.PRIMARY,
});

export const RestaurantText = styled(Text)(({ theme }) => ({
    color: COLORS.TERTIARY,
    marginTop: theme.spacing.xSmall,
    marginBottom: theme.spacing.xSmall,
    overflow: "hidden",
}));

export const RestaurantTagText = styled(Text)({
    color: COLORS.SECONDARY,
});

export const AboutSectionContainer = styled.div(({ theme }) => ({
    marginBottom: theme.spacing.large,
    marginTop: theme.spacing.medium,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.medium,
    alignItems: "center",
}));
export const AboutSectionTitleContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.small,
}));

export const AboutSectionTitle = styled(Text)({
    color: COLORS.PRIMARY,
});

export const AboutSectionText = styled(Text)({
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: TRUNCATE_LINE.LARGE,
    color: COLORS.SECONDARY,
    overflow: "hidden",
    "@media (max-height: 700px)": {
        WebkitLineClamp: TRUNCATE_LINE.MEDIUM,
    },
});

export const CTAContainer = styled(TextButton)(({ theme }) => ({
    width: "max-content",
    margin: `${theme.spacing.medium} 0 ${theme.spacing.xSmall} 0`,
}));

export const CTAText = styled(Text)({
    color: COLORS.PRIMARY,
});

export const SwipeImage = styled(Image)(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
    transform: "rotateX(180deg)",
}));

export const ConsentContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: `${theme.spacing.large} 0`,
    maxWidth: "90%",
}));

export const ConsentText = styled(Text)(({ theme }) => ({
    color: theme.colors.light.text_inverse_disabled,
}));
